import { AgentData } from '@core/models/agent-data.model';
import { Action, createReducer, on } from '@ngrx/store';
import * as actions from '@redux/actions';

export const initialAgentDataState: AgentData = {
  agentId: '',
  agentName: '',
  agentEmail: '',
  agentPhone: ''
};

const _agentDataReducer = createReducer(
  initialAgentDataState,
  on(actions.agentDataEdit, (state, { agentData }) => {
    return agentData;
  })
);

export function agentDataReducer(state: AgentData | undefined, action: Action) {
  return _agentDataReducer(state, action);
}
